import React, { useState } from 'react';
import { observer, inject } from 'mobx-react';
import { PopupOption as UIPopupOption } from '@shopee/chatbot-ui';
import { RadioValue } from '@shopee/chatbot-ui/lib/components/Radio';
import { PopupOptionProps as UIPopupOptionProps } from '@shopee/chatbot-ui/lib/components/PopupOption';

import { ButtonAction, getButtonAction } from '@/utils/getButtonData';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { assignParams } from '@/utils/dataTypeConvert';
import { INPUT_TYPE } from '@/utils/constants';
import { updateDialogueInfo } from '@/utils/sessionUtils';
import { InitStoreType } from '@/types/store/init';
import { ActionType } from '@/types/common';

export type CancelOrderProps = {
  taskbotInfo: any;
  action: {
    action_type: ButtonAction;
    task_bot_action: any;
  };
  popup: {
    title: string;
    footerText: string;
  };
  modal: {
    title: string;
    content: string;
    confirmText: string;
    cancelText: string;
  };
  options: {
    label: string;
    value: number | string;
  }[];
  orderId: string;
  refundDestination: string;
} & {
  initStore: InitStoreType;
  dialogueId: string;
  threadNodeId: string;
  threadId: string;
  threadIdV2: string;
  roundId: string;
  listPos: number;
  cardPosition: number; // 对应卡片的位置
};

const CancelOrder: React.FC<CancelOrderProps> = (props) => {
  const [popupActive, setPopupActive] = useState(true);
  const [optionValue, setOptionValue] = useState<string | number>();
  const { options = [], popup, modal } = props;

  const getOptionLabel = () => {
    const target = options.find((i) => i.value === optionValue);

    return target?.label;
  };

  const modalProps = {
    title: modal?.title,
    children: modal?.content,
    footer: {
      layout: 'horizontal',
      buttons: [
        {
          text: modal?.cancelText,
          style: { color: '#000' },
        },
        {
          text: modal?.confirmText,
          action: {
            _actualText_: getOptionLabel(),
            func: getButtonAction(ButtonAction.JumpNode),
            info: props,
            nextParams: {
              message_text: getOptionLabel(),
              input_type: INPUT_TYPE.BUTTON,
              session_id: props.initStore.sessionId,
              dialogue_id: props.dialogueId,
              thread_node_id: props.threadNodeId,
              thread_id: props.threadId,
              thread_id_v2: props.threadIdV2,
              round_id: props.roundId,
              is_bypass: props?.action?.task_bot_action?.is_bypass || false,
              message_extra: {
                params: {
                  cancel_reason_code: optionValue,
                  order_id: props.orderId,
                  refund_destination: props.refundDestination,
                },
                task_bot_action: {
                  ...(props?.action?.task_bot_action || {}),
                  task_bot_info: props.taskbotInfo,
                  ...{ params: assignParams(props.action.task_bot_action.params, { cancel_reason_code: optionValue! }) },
                },
              },
            },
            callback: (res: any) => {
              if (res?.fe_action?.action_type === ActionType.HideCancelButton) {
                updateDialogueInfo({ isCancelOrderDisabled: true }, props.cardPosition);
              }
            },
          },
        },
      ],
    },
  };

  return (
    <UIPopupOption
      showConfirm
      popupProps={{
        active: popupActive,
        title: popup?.title,
        onClose: () => setPopupActive(false),
      }}
      radioGroupProps={{
        value: optionValue,
        options: options,
        layout: 'vertical',
        onChange: (v: RadioValue) => setOptionValue(v),
      }}
      footerProps={{
        disabled: !optionValue,
        text: popup.footerText,
        onClick: () => {
          setPopupActive(false);
        },
      }}
      modalProps={modalProps as UIPopupOptionProps['modalProps']}
    />
  );
};

export default inject(getChildInject('initStore'))(observer(CancelOrder));
